import { environment } from '../../../environments/environment';

const upload = `${environment.apiUrl('upload')}`

export const UrlUploadApi = `${upload}/api/arquivo`;

export const UrlUploadApiDownload = `${upload}/api/arquivo/download`;


